<template>
	<main>
		<Header />
		<!-- Services Section -->
		<section class="py-5">
			<div class="container">
				<h3 class="text-center mb-4">
					Sorry, we're not sure where you're going...
				</h3>
				<p>
					Looks like you've found yourself at a location that doesn't exist, or
					at least on that we don't recognize. Maybe you should
					<a href="/">head back to the main page</a>
				</p>
				<img
					alt="a cartoon no-mosquitoes sign"
					class="center-block"
					height="300"
					src="/static/img/anti-mosquito-sign.jpg"
					width="300"
				/>
			</div>
		</section>
	</main>
</template>

<script setup lang="ts">
import Header from "@/rmo/components/Header.vue";
</script>
